import * as React from 'react';
import { classes, style } from 'typestyle';
import { CheckboxAllIcon, CheckboxOneIcon } from './icons/Icons';
import { checkboxesStyle, CheckboxStyleTypes } from '../../../styles/checkbox';
import { GrayDark, White } from '../../..';
class CheckboxInput extends React.Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { checked = false } = this.props;
            this.props.onChange(!checked);
        };
    }
    render() {
        const { name, checked = false, all = false, className, disabled = false, styleType } = this.props;
        let icon = undefined;
        if (checked) {
            const color = disabled ? GrayDark : White;
            icon = all ? React.createElement(CheckboxAllIcon, { color: color }) : React.createElement(CheckboxOneIcon, { color: color });
        }
        return (React.createElement("div", { className: classes('ta-checkbox-input-container', checkboxInputContainerStyle, className) },
            React.createElement("div", { className: classes('ta-checkbox-input', !checked && !styleType && checkboxesStyle[CheckboxStyleTypes.UnselectedA], styleType && checkboxesStyle[styleType], checked && checkboxesStyle[CheckboxStyleTypes.SelectedA], name, checkboxInputStyle, disabled && checked && checkboxesStyle[CheckboxStyleTypes.DisabledSelectedA], disabled && !checked && checkboxesStyle[CheckboxStyleTypes.DisabledUnselected]), onClick: () => !disabled && this.handleClick() }, icon)));
    }
}
export default CheckboxInput;
const checkboxInputContainerStyle = style({
    display: 'inline-block',
});
const checkboxInputStyle = style({
    width: 24,
    height: 24,
    borderRadius: 8,
    cursor: 'pointer',
});
//# sourceMappingURL=CheckboxInput.js.map